import React, {Component} from 'react';
import Version from './version';

class Footer extends Component {
    render() {
        return (
            <footer style={{position: "fixed", bottom: "0", left: "50%", transform: "translate(-50%)", padding: "10px", color: "white", backgroundColor: "#1e1e1e", width: "100%"}}>
                Made by <a style={{color: "white"}} href="https://lexikonn.eu" target="_blank">Lexikonn.eu</a> | <Version/>
            </footer>
        );
    }
}

export default Footer;